const Ztudents = () => {
    return (
        <>
            <p className='Help__Subtitle'>Buscar</p>
            <img src='/img/support/help/instructor/group/7.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Buscar</span>?</p>
            <p>Permite localizar rápidamente un Ztudiante por nombre o usuario. Escribe el dato en el campo de búsqueda y Ztudia mostrará solo los resultados relacionados, ocultando los demás para facilitar la gestión.</p>
            
            <p className='Help__Subtitle'>Listado de Ztudiantes</p>
            <img src='/img/support/help/instructor/group/2.png' className='Help__Image' />
            <p>¿Cómo funciona el listado de Ztudiantes?</p>
            <p>Muestra todos los Ztudiantes asociados a grupos del instructor en una tabla con tres columnas:</p>
            <ul className='Help__List'>
                <li className='Help__List__Item'>Nombre: nombre del Ztudiante.</li>
                <li className='Help__List__Item'>Aoellidos: apellidos del Ztudiante.</li>
                <li className='Help__List__Item'>Usuario: identificador único del Ztudiante en Ztudia.</li>
            </ul>

            <p>En cada fila se incluyen botones de acción para gestionar al Ztudiante:</p>
            <img src='/img/support/help/instructor/group/3.png' className='Help__Image' />
            <p>Detalles: consulta información adicional como nombre completo y otros grupos en los que está registrado.</p>

            <img src='/img/support/help/instructor/group/4.png' className='Help__Image' />
            <p>Ocultar: archiva al Ztudiante para que no aparezca como activo en el grupo.</p>

            <img src='/img/support/help/instructor/group/5.png' className='Help__Image' />
            <p>Contraseña: restablece la contraseña del Ztudiante a la predeterminada (P@ssw0rd) para que pueda ingresar y cambiarla.</p>

            <p className='Help__Subtitle'>Detalles</p>
            <img src='/img/support/help/instructor/group/3.png' className='Help__Image' />
            <p>¿Qué muestra la opción <span className='Help__Text--Highlight'>Detalles</span>?</p>
            <p>Permite consultar información específica del Ztudiante: nombre, apellidos, usuario y los grupos en los que está registrado. Esta vista ayuda al instructor a tener una referencia completa del Ztudiante.</p>

            <p className='Help__Subtitle'>Ocultar</p>
            <img src='/img/support/help/instructor/group/4.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Ocultar</span>?</p>
            <p>Archiva al Ztudiante dentro del grupo para que no aparezca como activo, sin eliminarlo de Ztudia. Esta acción mantiene la información disponible para futuras consultas.</p>

            <p className='Help__Subtitle'>Contraseña</p>
            <img src='/img/support/help/instructor/group/5.png' className='Help__Image' />
            <p>¿Cómo funciona la opción <span className='Help__Text--Highlight'>Contraseña</span>?</p>
            <p>Si un Ztudiante olvida su contraseña, el instructor puede restablecerla con la clave predeterminada P@ssw0rd. El Ztudiante podrá ingresar nuevamente y cambiarla por una nueva.</p>
        </>
    )
}

export { Ztudents };